{"telefono":"053700250","direccion":"Calle Olmedo S/N Bolívar y Morales","email":"dinformatica@portoviejo.gob.ec"}